"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m9 4 3 3V5.0054c3.866 0 7 3.134 7 7 0 .9088-.1732 1.7773-.4884 2.574l1.5104 1.5104c.6253-1.2258.978-2.6139.978-4.0844 0-4.9706-4.0294-9-9-9V1L9 4zM7.0191 7.087C5.7707 8.3512 5 10.0883 5 12.0054c0 .9089.1732 1.7773.4885 2.5741L3.978 16.0898C3.3527 14.864 3 13.4759 3 12.0054c0-2.4694.9945-4.7065 2.6049-6.3327L7.019 7.087z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10v12h2v-2h6v2h2V10H7zm8 6v2H9v-2h6zm-6-2v-2h6v2H9z"
  })];
};

exports.default = _default;